export const eskTexts = {
	knowMore: 'Jakin gehiago',
	ngoPurpose:
		'La captación de fondos para proyectos de la ONG,mantenerle informado sobre la ONG y la evolución del proyecto para el que ha donado fondos y la emisión de certificados de desgravación fiscal.',
	termsPurpose:
		'Gestionar la relación negocial en todos sus ámbitos, así como su donación y su solicitud de certificado, y el envío de comunicaciones comerciales por vía electrónica.',
	termsRights:
		'Tiene derecho a acceder, rectificar y suprimir los datos, así como otros derechos, como se explica en la información adicional.',
	termsAdditionalInfo:
		'Puedes consultar información adicional y detallada sobre Protección de datos en nuestra página <a href="https://www.worldcoo.com/gdpr">web</a> o bien contactando en <a href="mailto:rgpd@worldcoo.com">rgpd@worldcoo.com</a>.',
	termsRecipients:
		'No se cederán datos a terceros, excepto a los encargados de tratamiento fuera de la UE, acogidos a Privacy Shield.',
	unexpectedError: 'Ustekabeko errore bat izan da',
	amountError: 'Diru kopuruak ez zuen balio',
	authError: 'Errore bat gertatu da ordainketa baimentzean',
	cardError: 'Errore bat gertatu da zure txartelarekin',
	referralError: 'Erreferentzia-errore bat egon da',
	transactionError: 'Errore bat gertatu da transakzioan',
	resetFilters: 'garbitu iragazkiak',
	category: 'Kausa',
	basicNeeds: 'Oinarrizko beharrak',
	humanRights: 'Giza eskubideak',
	education: 'hezkuntza',
	emergency: 'Larrialdia',
	feeding: 'Elikadura',
	environment: 'Milieu',
	habitat: 'Ingurunea',
	health: 'Osasuna',
	clear: 'Garbitu',
	active: 'Aktiboa',
	finished: 'Amaitu',
	status: 'Baldintza',
	filters: 'Iragazkiak',
	year: 'Urtean',
	dedicateToTemplate:
		'¡Hola! Recibes este correo porqué {{donorName}} te ha dedicado una donación de {{amount}} {{currency}} para la ONG {{ngoName}} en la campaña {{campaignName}}. Esta donación te la ha dedicado a ti con la intención de hacer del mundo un lugar un poco mejor',
	dedicateToTemplateTitle: 'Zure dedikazioaren mezua.',
	dedicateToWarning:
		'Mezu hau Hartzaileari bidaliko zaio goian emandako helbide elektronikoan. Mezu hau bidaltzeko hartzaileari baimena eskatu diodala baieztatzen dut',
	dedicateToRecipientEmail: 'Ontvanger E-mail.',
	dedicateToRecipientName: 'Naam ontvanger.',
	dedicateDonationTitle: 'Nire dohaintza norbaiti eskaini nahi diot.',
	dedicateDonationMessage: 'Nire dohaintza norbaiti eskaini nahi nioke',
	responsable: 'Controller',
	purpose: 'Helburua',
	legitimation: 'Zilegitasuna',
	recipients: 'Jasotzaileak',
	rights: 'Eskubideak',
	ngoAdditionalInfoTitle: 'Kokapena eta informazio gehigarria',
	termsButton: 'Irakurri, onartu eta ulertu dut',
	id: 'NIF / NIE',
	taxId: 'CIF',
	passport: 'Pasaportea',
	others: 'Besteak',
	campaignAudited: 'Kanpainak egindako ikuskaritza',
	aCampaignBy: 'Kampaina hau eskeintzen du:',
	termsAndCons: 'Worldcoo Datuak Babesteko baldintzak',
	ngoTerms: 'Datuak Babesteko baldintzak',
	haveReadAndAccept: 'Irakurri, ulertu eta onartu ditut',
	acceptNgoTermsLink: '{{ngo}} babes baldintzak',
	acceptRecurrentTermsLink:
		'Irakurri, ulertu eta onartzen ditut <a class="terms_button" data-open-modal="recurrentTerms" data-modal-classes="terms-modal full-scroll" href="#">GKEen datuak babesteko baldintzak</a>',
	activities: 'Jarduerak',
	additionalInfo: 'Informazio gehigarria',
	anyComments: 'Iruzkin bat egin nahi duzu?',
	businessName: 'Sozietatearen izena',
	campaignObjectives: 'Kanpainaren helburuak',
	campaignFunded: 'Finantzatutako kanpaina!',
	campaigns: 'Kanpainak',
	cancel: 'Ezeztatu',
	cardBrandNotAccepted: 'Ez da onartzen mota honetako txartelik.',
	cardRegisteredSuccessfully: 'Txartela zuzen erregistratu da',
	cardsSupported: 'Onartuak diren txartelak:',
	certificateOnlyValidInExpeditionCountry:
		'Dohaintza-ziurtagiria soilik dohaintzen erakunde onuraduna inskribatuta dagoen jatorrizko herrialdearen izango da baliozkoa.',
	certificateNeededData: 'Dohaintza-ziurtagiria lortzeko behar diren datuak:',
	change: 'Aldatu',
	checkoutSuccess: 'Zure dohaintza zuzen burutu da, eskerrik asko parte hartzeagatik.',
	city: 'Herria',
	collectedFundsDistribution: 'Bildutako fondoak modu ekitatiboan banatuko dira honako proiektu hauen artean:',
	comments: 'Iruzkinak',
	company: 'Enpresa',
	confirm: 'Baieztatu',
	contactData: 'Harremanerako datuak',
	cookiesMessage: 'Gune honek cookieak erabiltzen ditu. Nabigatzen jarraitzen baduzu, onartzen dituzula ulertuko dugu.',
	country: 'Herrialdea',
	creditCard: 'Kreditu-txartela',
	dataReceivedSuccessfully: 'Zure datuak zuzen jaso ditugu.',
	description: 'Azalpena',
	directBeneficiaries: 'Zuzeneko onuradunak',
	directBeneficiariesDescription: 'Kanpainan garatutako ekintzengatik modu naturalean onuradun atera diren pertsonak',
	documentNumber: 'Agiri zk.',
	documentType: 'Agiri mota',
	donationAmount: 'Dohaintzaren zenbatekoa',
	donationAmountError: 'Dohaintzaren zenbatekoa ez da zuzena',
	donationAmountMinimumIs: 'Gutxieneko zenbatekoa {{amount}} da',
	donationCertificate: 'Dohaintza ziurtagiria',
	donations: 'Dohaintzak',
	donors: 'Dohaintza-emailea',
	donated: 'Dohaintzan emanak',
	donatedOf: 'Honek dohaintzan emanak',
	donateMonthly: 'Hilero dohaintzan eman',
	donationOnBehalf: 'Dohaintza egin honen izenean',
	door: 'Atea',
	email: 'Posta elektronikoa',
	fillFollowingFields: 'Bete eremu hauek',
	finish: 'Amaitu',
	floor: 'Solairua',
	funded: 'Finantzatua',
	genericCardError: 'Errore bat gertatu da zure txartelarekin.',
	goBack: 'Itzuli',
	identityDocument: 'Nortasun agiria',
	indicateDataToIdentify: 'Adierazi datu hauek, identifika zaitzagun:',
	indirectBeneficiaries: 'Zeharkako onuradunak',
	indirectBeneficiariesDescription:
		'Identifika daitezkeen pertsonak, kanpainan garatutako ekintzen ondorioz efektu potentzial bat jasotzen dutenak.',
	inDoubtContactHere: 'Edozein zalantzarako, gurekin harri zaitezke harremanean hemen:',
	informYouViaMail: 'Xehetasunez jakinaraziko dizugu posta elektronikoaren bidez.',
	makeDonation: 'Dohaintza egin',
	makeOneTimeDonation: 'Uneko dohaintza egin',
	makeYourDonation: 'Egin zure dohaintza',
	manageMyDonations: 'Nire dohaintzak kudeatu',
	manyThanks: 'Eskerrik asko!',
	modifyAmount: 'Dohaintzan emandako zenbatekoa aldatu',
	modifyRecurrentDonationSuccess:
		'<p class="margin-top-40">Zure eskaera zuzen jaso duzu.</p><p>Egun batzuen buruan e-posta bat bidaliko dizugu, eskatu dizkiguzun aldaketak egin ditugula jakinaraziz.</p><p>Zalantzaren bat baduzu, gurekin harremanean jarri zaitezke hemen:</p><p class="margin-top-20"><strong><a href="mailto:contact@worldcoo.com">contact@worldcoo.com</a></strong></p>',
	modifyRecurrentDonationTitle: 'Jada dohaintza-emaile bazara, hemen alda edo ezezta dezakezu zure dohaintza:',
	moreInfo: 'Informazio gehiago',
	name: 'Izena',
	next: 'Hurrengoa',
	otherAmount: 'Beste zenbateko bat',
	overlayError:
		'<p>Errore bat gertatu da.</p><p>Mesedez, saiatu berriro geroago edo jarri gurekin harremanean hemen:</p><p><strong>contact@worldcoo.com</strong></p>',
	particular: 'Partikularra',
	paymentData: 'Ordainketa-datuak',
	paymentType: 'Ordaintzeko era',
	personalData: 'Datu pertsonalak',
	pleaseFillFields: 'Mesedez, bete hurrengo datu hauek:',
	postalCode: 'Posta-kodea',
	province: 'Probintzia',
	raised: 'Bilduta',
	raisedTillNow: 'Orain arte bilduta:',
	recurrentFormError:
		'Errore bat gertatu da zure eskaera prozesatzean. Mesedez, saiatu geroago edo jarri gurekin harremanean hemen:',
	region: 'Eskualdea',
	repeatEmail: 'Errepikatu posta elektronikoa',
	repsolEmployeesPortal: 'Langileen atari solidarioa',
	seeCampaigns: 'Ikusi kanpainak',
	send: 'Bidali',
	share: 'Partekatu',
	sorry: 'Sentitzen dugu!',
	stairNumber: 'Eskailera',
	stopMakingDonation: 'Hilero dohaintza egiteari utzi',
	step1: '1. urratsa',
	step2: '2. urratsa',
	step3: '3. urratsa',
	step4: '4. urratsa',
	streetName: 'Kalearen izena',
	streetNumber: 'Zk.',
	streetType: 'Kale mota',
	summary: 'Laburpena',
	surname: 'Abizenak',
	telefonicaUseCorporateMail:
		'* Si eres empleado de Telefónica en activo utiliza preferiblemente tu correo electrónico corporativo.',
	thanks: 'Milesker!',
	typeTheAmount: 'Sartu zenbatekoa',
	unavailableLanguageMessage:
		'Kanpaina honen edukia ez dugu espainieraz. Zeure hizkuntzan eduki gehiago eskaintzeko lanean ari gara etengabe. Eskerrik asko zure pazientziagatik.',
	updatesAndLinks: 'Eguneratzeak eta estekak',
	validationEqualFields: '{{label}} eta {{fieldName}} eremuak ez dira berdinak',
	validationIsRequired: '{{label}} eremua nahitaezkoa da',
	validationValidEmail: '{{label}} eremua ez da baliozko e-posta bat',
	viewCampaignInfo: 'Ikusi kanpainaren informazioa',
	viewInfo: 'Ikusi informazioa',
	wantCertificate: 'Dohaintzaren egiaztagiri bat nahi dut',
	wantWorldcooNewsletter: 'Worldcoori buruzko informazioa jaso nahi dut',
	whatIsNewAmount: 'Esaiguzu dohaintzan eman nahi duzun zenbateko berria ({{currency}}):',
	whatYouWantToDo: 'Zer egin nahi duzu?',
	whoWillBenefit: 'Nor izango da onuradura?',
	youCanAlsoDonateOneTime: 'Uneko dohaintza bat ere egin dezakezu horietako edozeinetan sartuta.',
	yourDonationWillBeCharged: 'Zure dohaintza hilabete bakoitzaren 15ean kargatuko da.',
	yourRequestIsProcessing: 'Zure eskaera prozesatzen ari da. Mesedez, itxaron segundo batzuk',
	youSureCancelRecurrentDonation: 'Hilero dohaintza egiteari utzi nahi diozula berresten duzu?',
	ngoTermsTitle: 'Datuak Babesteari buruzko oinarrizko informazioa',
	ngoLegitimation: 'La base legal para el tratamiento de sus datos es la obtención de su consentimiento.',
	ngoRecipients: 'No se cederán datos a terceros salvo que exista obligación legal para ello.',
	ngoAdditionalInfo:
		'Puedes consultar información adicional y detallada sobre Protección de datos en nuestra página web o bien contactando en rgpd@worldcoo.com.',
	ngoAdditionalInfoEmail:
		'You can consult the additional and detailed information on Data Protection on the website of each NGO.',
	ngoAdditionalInfoUrl: 'Datuen babesari buruzko informazio osagarria eta zehatza gure webgunean kontsulta dezakezu: ',
	amountMustBeGreaterThanZero: 'Kopuruak 0 baino handiagoa izan behar du',
	amountMustBeLowerThan3000: 'Kopuruak 3000 baino gutxiago izan behar du',
	metafieldsNoTicket: '0. errenkada. Dohaintza sarrerarik gabe',
	metafieldsTickets:
		'Zenbat gonbidapen behar dituzu kontzerturako? Gogoan izan emandako 10 euro bakoitzeko gonbidapena jasotzen duzula.',
};
